import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import CashCollectedProgressMeter from './CashCollectedProgressMeter';
import DrrAcheivedToday from './DrrAcheivedToday';
import cx from 'classnames';
import styles from './index.module.scss';
import { LevelIcon } from '@cp/src/assets/icons/LevelIcon';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const EmiCollected = ({ loading }: { loading: boolean }) => {
  const emiCollectedData = useSelector(
    (state: RootState) => state.telePerformanceDashboard.emiCollectedOverview
  );
  const {
    emiCollected,
    cycleEmiTarget,
    lastAllocationLevel,
    allocatedCasesCount,
    daysRemainingInAllocation,
    totalEmiAllocated
  } = emiCollectedData;
  return (
    <SuspenseLoader
      loading={loading}
      fallBack={
        <div className={cx(styles.card, 'min-w-[28%] height-[90%]')}>
          <LineLoader
            childrenType="DISPLAY"
            lineWidth={100}
            numberOfLines={1}
            lineStyle={cx(styles.loader, styles.loaderRoundedTop)}
          />
          <LineLoader
            childrenType="DISPLAY"
            lineWidth={100}
            numberOfLines={9}
            lineStyle={styles.loader}
          />
          <LineLoader
            childrenType="DISPLAY"
            lineWidth={100}
            numberOfLines={1}
            lineStyle={cx(styles.loader, styles.loaderRoundedBottom)}
          />
        </div>
      }
    >
      <div
        className={cx({
          ['flex flex-col justify-between p-4 gap-3']: true,
          [styles.card]: true,
          [styles.targetAchivedCard]: emiCollected >= (cycleEmiTarget || totalEmiAllocated)
        })}
      >
        <CashCollectedProgressMeter />
        <DrrAcheivedToday />
        <div className="flex flex-col gap-[2px]">
          <div className="flex flex-row justify-between items-center bg-[var(--bg-secondary)] rounded-t-lg px-3 py-[6px]">
            <Typography variant="p5" color="var(--grayscale-2)">
              Performance at allocation
            </Typography>
            <LevelIcon
              fontClassName={''}
              level={lastAllocationLevel}
              color={'var(--teal-color-1)'}
            />
          </div>
          <div className="flex flex-row justify-between items-center bg-[var(--bg-secondary)] px-3 py-[6px]">
            <Typography variant="p5" color="var(--grayscale-2)">
              Allocated cases
            </Typography>
            <Typography variant="h2" color="var(--grayscale-2)">
              {allocatedCasesCount}
            </Typography>
          </div>
          <div className="flex flex-row justify-between items-center bg-[var(--bg-secondary)] rounded-b-lg px-3 py-[6px]">
            <Typography variant="p5" color="var(--grayscale-2)">
              Days remaining
            </Typography>
            <Typography variant="h2" color="var(--grayscale-2)">
              {daysRemainingInAllocation}
            </Typography>
          </div>
        </div>
      </div>
    </SuspenseLoader>
  );
};

export default EmiCollected;
